import React, { Component } from "react";
import { Fetch } from "../../utils/fetch";
import Navbar from "../../components/newNavBar";
import "./profile.scss";
import {
  Button,
  Modal,
  Input,
  message,
  Table,
  Select,
  ConfigProvider,
} from "antd";
import jwt from "../../utils/jwt";
import Loader from "../../utils/loader";
import PocDetails from "../../components/PocDetails";
import MobileMainHeader from "../../components/headers/mobileMainHeader";
import { MenuSlideDrawer } from "../../components/slideDrawer/SlideDrawer";
import SideMenu from "../../components/Layout/SideMenu";
import { operatorType, businessModelType } from "../../config";
import moment from "moment";

const { TextArea } = Input;

const { Option } = Select;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Signed On",
    dataIndex: "time",
    align: "center", // Center content
  },
  {
    title: "Download",
    dataIndex: "download",
    render: ({ download }) => {
      return (
        <button className="downloadButton" onClick={download}>
          Download
        </button>
      );
    },
    align: "center", // Center content
  },
];

class Profile extends Component {
  state = {
    profile: {},
    loading: true,
    isNavBarOpen: false,
    showPocModal: false,
    isEdit: false,
    name: "",
    mobile: null,
    area: "",
    showSideMenu: false,
    fileName: "No file chosen",
  };

  async componentDidMount() {
    try {
      const token = localStorage.getItem("idToken");
      const decodedToken = jwt.decode(token);
      const userMobileNo = decodedToken.mobileNo;
      let email = decodedToken.email;
      let userName = decodedToken.name || decodedToken.mgName;
      let userType = decodedToken.userType || "OPERATOR";
      let selectedAdminView = "BUSOWNER";

      if (sessionStorage.getItem("userType")) {
        userType = sessionStorage.getItem("userType");
        selectedAdminView = sessionStorage.getItem("userType");
      } else if (decodedToken && decodedToken.isElectricUser) {
        userName = decodedToken.electricName;
        email = decodedToken.electricEmail;
        userType = "ELECTRIC";
      }

      const regex =
        /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobile = regex.test(navigator.userAgent);
      const profile = await this.fetchProfile(userMobileNo, userType);
      const departments = [
        { value: "SALES", label: "SALES" },
        { value: "OPERATIONS", label: "OPERATIONS" },
        { value: "PICKUPS", label: "PICKUPS" },
      ];
      const cancelledChequeDetails =
        profile &&
        profile.cancelledChequeDetails &&
        profile.cancelledChequeDetails.status
          ? profile.cancelledChequeDetails.status
          : undefined;

      const showChequeDetails = userType == "OPERATOR" && profile;
      const showAgreement =
        (userType === "OPERATOR" || userType === operatorType.BUSOWNER) &&
        profile;

      let userAgreement;
      if (showAgreement) {
        userAgreement = await this.fetchAgreement();
      }

      let isAdmin = false,
        operators = [],
        businessModel = [
          ...businessModelType,
          { value: "CABOWNER", label: "CABOWNER" },
        ];
      const allowed = [
        "mg_operator_admin",
        "electric_operator_admin",
        "gds_operator_admin",
        "cab_operator_admin",
      ];

      if (
        decodedToken &&
        decodedToken.adminPrivileges &&
        allowed.some((r) => decodedToken.adminPrivileges.includes(r))
      ) {
        isAdmin = true;

        const privilegeToBusinessModelMap = {
          mg_operator_admin: { value: "BUSOWNER", label: "MG" },
          electric_operator_admin: { value: "ELECTRIC", label: "ELECTRIC" },
          gds_operator_admin: { value: "OPERATOR", label: "GDS" },
          cab_operator_admin: { value: "CABOWNER", label: "CABOWNER" },
        };

        businessModel = decodedToken.adminPrivileges
          .filter((privilege) => privilegeToBusinessModelMap[privilege])
          .map((privilege) => privilegeToBusinessModelMap[privilege]);

        if (selectedAdminView) {
          operators = await this.fetchOperators(selectedAdminView);
        } else {
          operators = await this.fetchOperators(businessModel[0].value);
          selectedAdminView = businessModel[0].value;
        }
      }
      const selectedOperator = sessionStorage.getItem("tempUserId")
        ? operators.find(
            (op) => op._id === sessionStorage.getItem("tempUserId"),
          ).name
        : "";

      this.setState({
        profile,
        loading: false,
        userMobileNo,
        userName,
        isAdmin,
        operators,
        businessModel,
        email: profile && profile.email ? profile.email : email ? email : "",
        userType,
        isMobile,
        userAgreement,
        showAgreement,
        departments,
        showChequeDetails,
        cancelledChequeDetails,
        selectedAdminView,
        selectedOperator,
      });
    } catch (err) {
      console.log(err);
    }
  }

  downloadDoc = async (_id) => {
    const url = `/user/signedAgreement/${_id}`;
    const options = { method: "GET" };
    const response = await Fetch(url, options);
    const downloadUrl = response;

    window.open(downloadUrl, "_blank");
  };

  fetchAgreement = async () => {
    const url = `/user/agreement`;
    const options = {
      method: "get",
    };

    const response = await Fetch(url, options);

    if (Array.isArray(response) && response.length > 0) {
      const data = response.map((item) => ({
        key: item._id,
        name: item.name,
        time: moment(item.operatorEsignDetails.signedOn).format("DD-MMM-YY"),
        download: {
          download: () => this.downloadDoc(item._id),
        },
      }));
      return data;
    }
    // message.error("Something went wrong");
    return [];
  };

  fetchProfile = async (mobileNo, userType) => {
    let url = `/user/details?mobileNo=${mobileNo}`;
    if (userType === operatorType.CABOWNER) {
      url = `/mg/user/details?mobileNo=${mobileNo}`;
    }
    const options = {
      method: "get",
    };

    const response = await Fetch(url, options);

    if (Array.isArray(response) && response.length > 0) {
      return response[0];
    }
    return;
  };

  fetchOperators = async (selectedAdminView) => {
    let url = `/user/fetchOperators?view=${selectedAdminView}`;

    const options = {
      method: "get",
    };

    const response = await Fetch(url, options);

    if (Array.isArray(response) && response.length > 0) {
      return response;
    }
    return;
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleChange = (key, value) => {
    if (key === "mobile") {
      const re = /^[0-9\b]+$/;
      if (value.length < 11 && (value === "" || re.test(value))) {
        this.setState({ mobile: value });
      }
    } else {
      this.setState({ [key]: value });
    }
  };

  addPoc = async () => {
    const { name, area, mobile, profile, selectedIndex, isEdit, department } =
      this.state;
    let { pocList } = profile;
    if (selectedIndex !== undefined) {
      pocList[selectedIndex] = {
        name,
        area,
        department,
        mobile: mobile.toString(),
      };
    } else {
      let newData = {
        name,
        area,
        department,
        mobile: mobile.toString(),
      };
      if (pocList) {
        pocList.push(newData);
      } else {
        pocList = [];
        pocList.push(newData);
      }
    }
    const url = `/user/update`;
    const options = {
      method: "post",
      data: {
        pocList,
      },
    };

    const response = await Fetch(url, options);

    if (!Array.isArray(response)) {
      message.error("Something went wrong");
    }
    if (response) {
      if (isEdit) {
        message.success("POC is Updated");
      } else {
        message.success("POC is added");
      }
    }

    this.setState({
      profile: response[0],
      showPocModal: false,
      isEdit: false,
      name: "",
      mobile: null,
      area: "",
    });
  };

  editPoc = async (data) => {
    const { profile } = this.state;
    const { pocList } = profile;
    const { name, area, mobile, department } = pocList[data];
    this.setState({
      name,
      area,
      department,
      mobile,
      showPocModal: true,
      isEdit: true,
      selectedIndex: data,
    });
  };

  toggleSideMenu = () => {
    const { showSideMenu } = this.state;
    this.setState({
      showSideMenu: !showSideMenu,
    });
  };

  handleOperatorTypeChange = (value) => {
    sessionStorage.setItem("userType", value);
    this.props.history.replace("/");
  };

  handleFileChange = (event) => {
    const file = event.target.files[0];
    this.setState({
      fileName: file ? file.name : "Choose a file",
      selectedFile: event.target.files[0],
    });
  };

  requestChange = async () => {
    const url = `/user/cancelledChequeChange`;
    const options = {
      method: "get",
    };

    const response = await Fetch(url, options);

    if (Array.isArray(response)) {
      const cancelledChequeDetails =
        response[0].cancelledChequeDetails &&
        response[0].cancelledChequeDetails.status
          ? response[0].cancelledChequeDetails.status
          : null;
      this.setState({ cancelledChequeDetails, changeRequested: false });
      message.success("Updated");
    }
    return;
  };
  upload = async () => {
    try {
      let { selectedFile } = this.state;
      const formData = new FormData();

      if (!selectedFile) {
        message.error("please upload a file");
        return;
      }

      formData.append("myFile", selectedFile);

      const url = `/user/chequeUpload`;

      const options = {
        method: "post",
        data: formData,
        headers: { "content-type": "multipart/form-data" },
      };

      let response = await Fetch(url, options);
      if (Array.isArray(response)) {
        const cancelledChequeDetails =
          response[0].cancelledChequeDetails &&
          response[0].cancelledChequeDetails.status
            ? response[0].cancelledChequeDetails.status
            : null;
        this.setState({ cancelledChequeDetails, btnLoader: false });
      } else {
        message.error("Cheque is Not Added");
        return;
      }
    } catch (err) {
      this.setState({
        tableLoader: false,
        showReimbursementModal: false,
      });
      message.error("Reimbursement is Not Added");
      message.error(err);
    }
  };
  setOperator = async (selectedAdminView) => {
    let operators = await this.fetchOperators(selectedAdminView);
    this.setState({ selectedAdminView, operators, selectedOperator: "" });
  };

  showAdmin = () => {
    const { selectedOperator, selectedAdminView , isOperatorSelected } = this.state;
    if (selectedOperator && isOperatorSelected) {
      sessionStorage.setItem("tempUserId", selectedOperator);
      sessionStorage.setItem("userType", selectedAdminView);
      this.props.history.replace("/");
    } else {
      message.error("Please select an operator");
    }
  };

  render() {
    const {
      showPocModal,
      profile,
      loading,
      name,
      mobile,
      area,
      userMobileNo,
      userName,
      isMobile,
      isEdit,
      department,
      departments,
      fileName,
      showChequeDetails,
      showAgreement,
      cancelledChequeDetails,
      userAgreement,
      email,
      changeRequested = false,
      selectedOperator = "",
      operators = [],
      isAdmin = false,
      businessModel,
      selectedAdminView = "BUSOWNER",
      showSideMenu,
    } = this.state;

    let active = 3;

    if (loading) {
      return (
        <div className="loader">
          <Loader />
        </div>
      );
    } else if (isMobile) {
      return (
        <div class="container">
          <MobileMainHeader toggleSideMenu={this.toggleSideMenu} />

          {showSideMenu ? (
            <MenuSlideDrawer
              toggleSideMenu={this.toggleSideMenu}
              showSideMenu={showSideMenu}
              isMobile={isMobile}
            >
              <SideMenu
                active={active}
                toggleSideMenu={this.toggleSideMenu}
                isMobile={isMobile}
              />
            </MenuSlideDrawer>
          ) : null}
          {!profile ? (
            <div className="caution">
              <span>
                You’ve not registered with us in this model. Please reach out to
                your POC.
              </span>
            </div>
          ) : null}
          {!cancelledChequeDetails && showChequeDetails ? (
            <div className="uploadWarning">
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/operator/user/exclamiation.svg"
                alt="exclamation mark black"
              />
              <span>Upload cancelled cheque to continue using the account</span>
            </div>
          ) : null}

          <div
            className="profileUserDetails"
            style={{
              margin:
                !cancelledChequeDetails && showChequeDetails
                  ? "15px 16px"
                  : "30px 16px",
            }}
          >
            {showChequeDetails ? (
              cancelledChequeDetails === "APPROVED" ? (
                <div className="uploadApproved">
                  <div>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                      alt="exclamation mark black"
                    />
                    <span>
                      Bank details have been verified and mapped to your account
                    </span>
                  </div>
                  <div onClick={() => this.setState({ changeRequested: true })}>
                    <span>Request a Change</span>
                  </div>
                </div>
              ) : cancelledChequeDetails === "PENDING" ? (
                <div className="uploadPending">
                  <div>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/clockwise.svg"
                      alt="exclamation mark black"
                    />
                    <span>
                      Your bank details are being verified. Please contact our
                      team for more details.
                    </span>
                  </div>
                </div>
              ) : cancelledChequeDetails === "CHANGE_REQUESTED" ? (
                <div className="uploadPending">
                  <div>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/operator/info.svg"
                      alt="exclamation mark black"
                    />
                    <span>
                      A request has been raised to change your bank details
                    </span>
                  </div>
                </div>
              ) : (
                <div className="chequeUpload">
                  <div className="uploadContainer">
                    <div className="uploadHeader">
                      <span>Upload Cancelled Cheque</span>
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/declined/declined.svg"
                          alt="exclamation mark"
                        />
                        <span>Rejected</span>
                      </div>
                    </div>
                    <div className="uploadContent">
                      <div className="upload-container">
                        <span className="file-label">{fileName}</span>

                        <input
                          type="file"
                          id="file-input"
                          onChange={this.handleFileChange}
                          style={{ display: "none" }}
                        />

                        <label htmlFor="file-input" className="choose-file">
                          Choose a File
                        </label>
                      </div>

                      <button className="btn" onClick={() => this.upload()}>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/user/upload.svg"
                          alt="uploadIcon"
                        />
                        Upload
                      </button>
                    </div>
                  </div>
                </div>
              )
            ) : null}
            <div className="userInfoHeading">
              <span className="user">Account Details</span>
              <span className="subUserHeading">
                View complete details of your operator account
              </span>
            </div>
            <div className="Details">
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/operatorDashBoard/home/profilePhoto.svg"
                alt="profilePhoto"
              />
              <div>
                <span className="Bold">{userName}</span>
                <div className="userDetail">
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/header/phone.svg"
                    alt="phone"
                  />
                  <span className="light">{userMobileNo}</span>
                </div>
                <div className="userDetail">
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/header/email.svg"
                    alt="emailId"
                  />
                  <span className="light">{email}</span>
                </div>
              </div>
            </div>
            {profile && profile.pocList && profile.pocList.length > 0 ? (
              <>
                <div className="PocHeader">
                  <p className="user">POC Details</p>
                  <div
                    className="PocBtn"
                    onClick={() => this.setState({ showPocModal: true })}
                  >
                    <span className="Poctxt">Add New POC</span>
                  </div>
                </div>
                <PocDetails
                  editPoc={this.editPoc}
                  details={profile.pocList}
                  isMobile={isMobile}
                />
              </>
            ) : null}
            {isAdmin ? (
              <div className="adminViewSelect">
                <div>
                  <p>Select Type</p>
                  <Select
                    allowClear
                    showSearch
                    style={{ width: "100%" }}
                    value={selectedAdminView}
                    onChange={(value) => this.setOperator(value)}
                  >
                    {businessModel.map((s) => (
                      <Option value={s.value}>{s.label}</Option>
                    ))}
                  </Select>
                </div>
                <div>
                  <p>Select Operator</p>
                  <Select
                    allowClear
                    placeholder="Operator Name"
                    showSearch
                    style={{ width: "100%" }}
                    value={selectedOperator}
                    onChange={(value) =>
                      this.setState({
                        selectedOperator: value,
                        isOperatorSelected: true,
                      })
                    }
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {operators.map((s) => (
                      <Option value={s._id} key={s._id}>
                        {s.name}
                      </Option>
                    ))}
                  </Select>
                </div>

                <button onClick={() => this.showAdmin()}>
                  <span>Apply</span>
                </button>
              </div>
            ) : null}
            {showAgreement ? (
              <div className="Agreements">
                <p className="user">Agreements</p>
                <ConfigProvider
                  theme={{
                    components: {
                      Table: {
                        headerBg: "#454545",
                        headerColor: "#FFF",
                      },
                    },
                  }}
                >
                  <Table
                    columns={columns}
                    dataSource={userAgreement}
                    bordered={true}
                    pagination={false}
                  />
                </ConfigProvider>
              </div>
            ) : null}
          </div>

          <Modal
            open={showPocModal}
            onCancel={() =>
              this.setState({
                showPocModal: false,
                isEdit: false,
                name: "",
                mobile: null,
                area: "",
              })
            }
            footer={null}
          >
            <div className="POCModal">
              <p className="modalHeader">{isEdit ? "Edit POC" : "Add POC"}</p>
              <p className="subHeader">Please enter the details </p>
              <TextArea
                autoSize
                value={name}
                onChange={(e) => this.handleChange("name", e.target.value)}
                placeholder="Name"
                className="textArea"
              ></TextArea>
              <TextArea
                autoSize
                value={area}
                onChange={(e) => this.handleChange("area", e.target.value)}
                placeholder="Area"
                className="textArea"
              ></TextArea>
              <TextArea
                autoSize
                value={mobile}
                onChange={(e) => this.handleChange("mobile", e.target.value)}
                maxLength={10}
                placeholder="Mobile Number"
                className="textArea"
              ></TextArea>

              <Button onClick={this.addPoc} className="addBtn">
                {isEdit ? "Save" : "Add"}
              </Button>
            </div>
          </Modal>

          <Modal
            open={changeRequested}
            onCancel={() =>
              this.setState({
                changeRequested: false,
              })
            }
            onClose={() =>
              this.setState({
                changeRequested: false,
              })
            }
            footer={null}
          >
            <div className="changeRequestModal">
              <p>Are you sure?</p>
              <span>
                A request will be sent to admin team to change the bank details.
              </span>
              <div onClick={() => this.requestChange()}>
                <span>Raise Request</span>
              </div>
              <div onClick={() => this.setState({ changeRequested: false })}>
                {" "}
                <span>Cancel</span>
              </div>
            </div>
          </Modal>
        </div>
      );
    } else {
      return (
        <div>
          <Navbar isMobile={isMobile} />
          <div className="container">
            {showChequeDetails ? (
              <div className="cheque">
                {cancelledChequeDetails === "APPROVED" ? (
                  <div className="chequeApproved">
                    <div className="uploadApproved">
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/accepted.svg"
                          alt="exclamation mark black"
                        />
                        <span>
                          Bank details have been verified and mapped to your
                          account
                        </span>
                      </div>
                      <div
                        onClick={() => this.setState({ changeRequested: true })}
                      >
                        <span>Request a Change</span>
                      </div>
                    </div>
                  </div>
                ) : cancelledChequeDetails === "PENDING" ? (
                  <div className="uploadPending">
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/clockwise.svg"
                        alt="exclamation mark black"
                      />
                      <span>
                        Your bank details are being verified. Please contact our
                        team for more details.
                      </span>
                    </div>
                  </div>
                ) : cancelledChequeDetails === "CHANGE_REQUESTED" ? (
                  <div className="uploadPending">
                    <div>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/info.svg"
                        alt="exclamation mark black"
                      />
                      <span>
                        A request has been raised to change your bank details
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="chequeUpload">
                    <div className="uploadWarning">
                      <div>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/operator/user/exclamiation.svg"
                          alt="exclamation mark black"
                        />
                        <span>
                          Upload cancelled cheque to continue using the account
                        </span>
                      </div>
                    </div>
                    <div className="uploadContainer">
                      <div className="uploadHeader">
                        <span>Upload Cancelled Cheque</span>
                        <div>
                          <img
                            src="https://d1flzashw70bti.cloudfront.net/original/images/declined/declined.svg"
                            alt="exclamation mark"
                          />
                          <span>Rejected</span>
                        </div>
                      </div>
                      <div className="uploadContent">
                        <div className="upload-container">
                          <span className="file-label">{fileName}</span>

                          <input
                            type="file"
                            id="file-input"
                            onChange={this.handleFileChange}
                            style={{ display: "none" }}
                          />

                          <label htmlFor="file-input" className="choose-file">
                            Choose a File
                          </label>
                        </div>

                        <button className="btn" onClick={() => this.upload()}>
                          <img
                            src="https://d1flzashw70bti.cloudfront.net/original/images/operator/user/upload.svg"
                            alt="uploadIcon"
                          />
                          Upload
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : null}

            <div className="userProfile">
              <span className="user">Account Details</span>
              <span className="subUser">
                View complete details of your operator account
              </span>
              {!profile ? (
                <span className="caution">
                  You’ve not registered with us in this model. Please reach out
                  to your POC.
                </span>
              ) : null}
            </div>
            <div className="Details">
              <div>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/operatorDashBoard/home/profilePhoto.svg"
                  alt="profilePhoto"
                />
                <div>
                  <span className="Bold">{userName}</span>
                  <div className="userDetail">
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/header/phone.svg"
                      alt="phone"
                    />
                    <span className="light">{userMobileNo}</span>
                  </div>
                  <div className="userDetail">
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/header/email.svg"
                      alt="emailId"
                    />
                    <span className="light">{email}</span>
                  </div>
                </div>
              </div>
            </div>
            {profile && profile.pocList && profile.pocList.length > 0 ? (
              <>
                <div className="PocHeader">
                  <p className="user">POC Details</p>
                  <div
                    className="PocBtn"
                    onClick={() => this.setState({ showPocModal: true })}
                  >
                    <p className="Poctxt">Add New POC</p>
                  </div>
                </div>
                <PocDetails
                  editPoc={this.editPoc}
                  details={profile.pocList}
                  isMobile={isMobile}
                />
              </>
            ) : null}
            {isAdmin ? (
              <div className="adminViewSelect">
                <div>
                  <p>Select Type</p>
                  <Select
                    allowClear
                    showSearch
                    style={{ width: "100%" }}
                    value={selectedAdminView}
                    onChange={(value) => this.setOperator(value)}
                  >
                    {businessModel.map((s) => (
                      <Option value={s.value}>{s.label}</Option>
                    ))}
                  </Select>
                </div>
                <div>
                  <p>Select Operator</p>
                  <Select
                    allowClear
                    placeholder="Operator Name"
                    showSearch
                    style={{ width: "100%" }}
                    value={selectedOperator}
                    onChange={(value) =>
                      this.setState({
                        selectedOperator: value,
                        isOperatorSelected: true,
                      })
                    }
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {operators.map((s) => (
                      <Option value={s._id} key={s._id}>
                        {s.name}
                      </Option>
                    ))}
                  </Select>
                </div>

                <button onClick={() => this.showAdmin()}>
                  <span>Apply</span>
                </button>
              </div>
            ) : null}
            {showAgreement ? (
              <div className="Agreements">
                <p className="user">Agreements</p>
                <ConfigProvider
                  theme={{
                    components: {
                      Table: {
                        headerBg: "#454545",
                        headerColor: "#FFF",
                      },
                    },
                  }}
                >
                  <Table
                    columns={columns}
                    dataSource={userAgreement}
                    bordered={true}
                    scroll={{ x: "max-content", y: isMobile ? "70vh" : null }}
                    pagination={false}
                  />
                </ConfigProvider>
              </div>
            ) : null}
            <Modal
              open={showPocModal}
              onCancel={() =>
                this.setState({
                  showPocModal: false,
                  name: "",
                  mobile: null,
                  area: "",
                })
              }
              footer={null}
            >
              <div className="POCModal">
                <p className="modalHeader">Add POC</p>
                <p className="subHeader">Please enter the details </p>
                <TextArea
                  autoSize
                  value={name}
                  onChange={(e) => this.handleChange("name", e.target.value)}
                  placeholder="Name"
                  className="textArea"
                ></TextArea>
                <TextArea
                  autoSize
                  value={area}
                  onChange={(e) => this.handleChange("area", e.target.value)}
                  placeholder="Area"
                  className="textArea"
                ></TextArea>
                <TextArea
                  autoSize
                  value={mobile}
                  onChange={(e) => this.handleChange("mobile", e.target.value)}
                  maxLength={10}
                  placeholder="mobileNo"
                  className="textArea"
                ></TextArea>
                <Select
                  placeholder="Select Department"
                  allowClear
                  value={department}
                  options={departments}
                  onChange={(value) => this.handleChange("department", value)}
                />

                <Button onClick={this.addPoc} className="addBtn">
                  Add
                </Button>
              </div>
            </Modal>
            <Modal
              open={changeRequested}
              onCancel={() =>
                this.setState({
                  changeRequested: false,
                })
              }
              onClose={() =>
                this.setState({
                  changeRequested: false,
                })
              }
              footer={null}
            >
              <div className="changeRequestModal">
                <p>Are you sure?</p>
                <span>
                  A request will be sent to admin team to change the bank
                  details.
                </span>
                <div onClick={() => this.requestChange()}>
                  <span>Raise Request</span>
                </div>
                <div onClick={() => this.setState({ changeRequested: false })}>
                  {" "}
                  <span>Cancel</span>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      );
    }
  }
}

export default Profile;
